import {useCallback, useContext, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {RESPONSE_STATUSES} from '@/src/app/constants/api';
import {
  selectClinicData,
  setClinicData,
} from '@/src/app/store/clinic/clinicDataSlice';
import {
  selectCountriesDictionarySlice,
  setCountriesDictionary,
  setCountriesDictionaryFetchingStatus,
} from '@/src/app/store/signUp/countriesDictionarySlice';
import useLoading from '@/src/hooks/useLoading';
import PopupContext from '@/src/popup/utils/PopupContext';
import ChangeClinicAddressPopupLayout from '@/src/profile/accountSettings/components/ChangeClinicAddressPopupLayout';
import updateClinicAddress from '@/src/profile/accountSettings/utils/updateClinicAddress';
import fetchCountriesDictionary from '@/src/signUp/emailStep/utils/fetchCountriesDictionary';

const ChangeClinicAddressPopup = () => {
  const {isLoading, setLoading} = useLoading();
  const {clinicData} = useSelector(selectClinicData);
  const countriesData = useSelector(selectCountriesDictionarySlice);
  const dispatch = useDispatch();
  const {closePopup} = useContext(PopupContext);

  const handleSubmitClick = useCallback(
    async ({address, zipcode, city_id}) => {
      setLoading(true);

      const {status, responseBody} = await updateClinicAddress(
        clinicData.id,
        address,
        zipcode,
        city_id
      );

      setLoading(false);

      if (status === RESPONSE_STATUSES.SUCCESS) {
        dispatch(setClinicData({clinicData: responseBody, isFetched: true}));
        closePopup();
      }
    },
    [clinicData]
  );

  const handleCancelClick = useCallback(() => {
    closePopup();
  }, []);

  useEffect(() => {
    const fetchCountriesData = async () => {
      const {responseBody, status} = await fetchCountriesDictionary();

      if (status === RESPONSE_STATUSES.SUCCESS) {
        dispatch(setCountriesDictionary(responseBody));
        dispatch(setCountriesDictionaryFetchingStatus(true));
      }
    };

    if (!countriesData.isFetched) {
      fetchCountriesData();
    }
  }, [countriesData]);

  if (!countriesData.isFetched) {
    return null;
  }

  return (
    <ChangeClinicAddressPopupLayout
      onCancelClick={handleCancelClick}
      onSubmitClick={handleSubmitClick}
      address={clinicData.address}
      zipcode={clinicData.zipcode}
      cityId={clinicData.city.id}
      stateId={clinicData.state.id}
      countryId={clinicData.country.id}
      countriesDictionary={countriesData.countriesDictionary.data}
      isLoading={isLoading}
    />
  );
};

export default ChangeClinicAddressPopup;
